// client/src/coms/video/videoDevicePrefs.js

const KEY_VIDEO_INPUT = 'coms_video_input_device_id';

export function getPreferredVideoInputDeviceId() {
  try {
    return String(localStorage.getItem(KEY_VIDEO_INPUT) || '').trim();
  } catch {
    return '';
  }
}

export function setPreferredVideoInputDeviceId(id) {
  const v = String(id || '').trim();
  try {
    if (!v) localStorage.removeItem(KEY_VIDEO_INPUT);
    else localStorage.setItem(KEY_VIDEO_INPUT, v);
  } catch {}
  return v;
}

export function emitVideoDevicePrefsChanged(detail) {
  const payload = detail && typeof detail === 'object' ? detail : {};
  try {
    window.dispatchEvent(new CustomEvent('coms-video-device-changed', { detail: payload }));
  } catch {
    try {
      window.dispatchEvent(new Event('coms-video-device-changed'));
    } catch {}
  }
}
